import {
  GetBillOfMaterialsResponse,
  GetBillOfMaterialsResponse_ReservoirItems,
} from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/aqora_service_pb';
import { TFunction } from 'i18next';
import { ResourceNameIdConverter } from '~/shared/models/ResourceNameIdConverter';
import { SystemModel } from '~/shared/models/system/SystemModel';

type PlainReservoirItem = Omit<
  GetBillOfMaterialsResponse_ReservoirItems,
  'subtotalGrossPrice'
>;

export type BillOfMaterialsItem = PlainReservoirItem & {
  subtotalGrossPrice: number;
  getTitle: (t: TFunction) => string;
};

type BillOfMaterialProduct = {
  title: string;
  image: string;
  linkUrl?: string;
  linkText?: string;
};

export class BillOfMaterialsModel {
  totalGrossPrice: number;

  totalM2Price: number;

  palletCount: number;

  items: BillOfMaterialsItem[];

  system: SystemModel;

  productsUsed: BillOfMaterialProduct[];

  constructor(
    billOfMaterialsResponse: GetBillOfMaterialsResponse,
    system: SystemModel,
  ) {
    this.system = system;
    this.totalGrossPrice = billOfMaterialsResponse.totalGrossPrice;

    this.totalM2Price = billOfMaterialsResponse.totalM2Price;

    this.palletCount = billOfMaterialsResponse.shippingInfo?.pallets ?? 0;

    this.items = billOfMaterialsResponse.items.map(
      ({ subtotalGrossPrice, ...item }) => ({
        ...item,
        subtotalGrossPrice,
        getTitle: this.getItemTitle(item),
      }),
    );

    this.productsUsed = billOfMaterialsResponse.productsUsed
      .map((product) => ({
        title: product.title,
        image: product.imageUrl,
        linkUrl: product.documents[0]?.url ?? undefined,
        linkText: product.documents[0]?.title ?? undefined,
      }))
      .filter((item) => item.image || item.linkUrl);
  }

  private getItemTitle(item: PlainReservoirItem) {
    return (t: TFunction) => {
      let title = t('billOfMaterials.table.titleAccessories');

      if (item.reservoirName) {
        const reservoirModel = this.system.reservoirById(
          ResourceNameIdConverter.reservoirNameToId(item.reservoirName),
        );
        title = t('billOfMaterials.table.titleReservoirItems', {
          reservoirTitle: reservoirModel?.title,
        });
      }

      return title;
    };
  }
}
